<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row top-space">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>Society of Economics and Social Statistics</h3></header>
            <img src="assets/img/society_of_economics_and_socia_statistics.jpg">
            <hr>
            <p>
              The Society of Economics and Social Statistics is an active student society at the University of Ruhuna. This Society consists of the students who follow the Special degrees in Economics and Social Statistics at the Faculty of Humanities and Social Sciences. The Society promotes innovative solutions for the field of Economics and Social Statistics.
            </p>
            <hr>
            <h4>Objectives</h4>
            <ul class="element-framed">
              <li>To motivate students to work in a practical environment</li>
              <li>To create global leaders with a good knowledge in Economics and Social Statistics, skills and good attitudes to serve the community</li>
            </ul>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Office Bearers</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <b>Advising Committee</b>
                    <figure class="professor-description">
                      Ms. De Silva, H.N.<br>
                      Ms. Jayasekara, A.J.
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>President</b>
                    <figure class="professor-description">Rathnayaka, R.M.D.C.</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Secretary</b>
                    <figure class="professor-description">Chamaleen, D.B.D</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice President</b>
                    <figure class="professor-description">Darshana, H.K.C.</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice Secretary</b>
                    <figure class="professor-description">Priyadarshani, I.</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Treasurer</b>
                    <figure class="professor-description">Mr. Peiris, L.K.K</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Treasurer</b>
                    <figure class="professor-description">Rajapaksha, D.H.G</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Editor</b>
                    <figure class="professor-description">Ms. De Silva, H.N.r</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Editor</b>
                    <figure class="professor-description">
                      Liyanage, R.P.G<br>
                      Madushani, P.K.I.
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Committee Members</b>
                    <figure class="professor-description">
                      Indunil, K.G.<br>
                      Wijayantha, J.J.<br>
                      Nirawadhya, N.<br>
                      Rohana, A.
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
